import React from 'react';
import { BarChart3, PieChart, Database, TrendingUp, ArrowRight } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  0: BarChart3,
  1: PieChart,
  2: Database,
  3: TrendingUp
};

const Services = () => {
  return (
    <section id="services" className="py-24 lg:py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="mb-16">
          <span className="label-text text-[rgba(35,35,35,0.5)] mb-4 block">What I Offer</span>
          <h2 className="section-title">Skills</h2>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-6">
          {services.map((service, idx) => {
            const Icon = iconMap[idx] || BarChart3;
            return (
              <div
                key={service.id}
                className="card-sharp p-8 group hover:bg-[#232323] transition-all duration-300"
              >
                {/* Icon & Title */}
                <div className="flex items-start gap-4 mb-6">
                  <div className="p-3 bg-[#38FF62] group-hover:bg-white transition-colors duration-300">
                    <Icon className="w-6 h-6 text-[#232323]" />
                  </div>
                  <div>
                    <h3 className="font-display text-xl font-semibold group-hover:text-white transition-colors duration-300">
                      {service.title}
                    </h3>
                  </div>
                </div>

                {/* Description */}
                <p className="font-body text-[rgba(35,35,35,0.7)] group-hover:text-[rgba(255,255,255,0.7)] mb-6 transition-colors duration-300">
                  {service.description}
                </p>

                {/* Features */}
                <div className="flex flex-wrap gap-2">
                  {service.features.map((feature, fIdx) => (
                    <span
                      key={fIdx}
                      className="px-3 py-1.5 bg-[rgba(35,35,35,0.05)] group-hover:bg-[rgba(255,255,255,0.1)] font-mono text-xs uppercase tracking-wider transition-colors duration-300 group-hover:text-white"
                    >
                      {feature}
                    </span>
                  ))}
                </div>

                {/* Arrow */}
                <div className="mt-6 flex justify-end">
                  <ArrowRight className="w-5 h-5 text-[rgba(35,35,35,0.3)] group-hover:text-[#38FF62] transition-colors duration-300" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;